module.exports = __webpack_public_path__ + "img/map_4.04286a92.png";